import RestService from '../services/rest';

// GET
async function getListIntegrationQueue(filterStartDate, filterEndDate, isBeeStock, id) {
  return RestService.getAuthenticated(
    'integration/integrationQueue/list',
    {
      filterStartDate,
      filterEndDate,
      isBeeStock,
      ...(id ? { id } : {}),
    },
  );
}

// PUT
async function resyncQueue(queueIds = [], isBeeStock) {
  return RestService.putAuthenticated('integration/resync', { queueIds, isBeeStock });
}

async function cancelInboundOrder(queueId) {
  return RestService.putAuthenticated('integration/cancelInboundOrder', { queueId });
}

export default {
  getListIntegrationQueue,
  resyncQueue,
  cancelInboundOrder,
};
